var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgObsLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M25.373 16a9.391 9.391 0 1 1-18.782 0 9.391 9.391 0 0 1 18.782 0M13.71 7.79c-1.27.63-2.213 1.886-2.502 3.279l.016.01c-.252 1.096-.068 2.268.433 3.278l.1.01c.282.025.563.05.841.1.984.207 1.889.79 2.464 1.616.768 1.049.941 2.502.485 3.725a4.03 4.03 0 0 1-2.482 2.408c-.844.3-1.768.257-2.618.009.95.429 2.023.594 3.043.38 1.328-.252 2.55-1.088 3.227-2.26-.487-.94-.62-2.07-.31-3.096.365-1.288 1.422-2.335 2.702-2.702a4.01 4.01 0 0 1 3.095.349c.963.532 1.669 1.477 1.95 2.539-.024-.8-.37-1.569-.814-2.224-.866-1.257-2.34-2.04-3.856-2.091-.708 1.256-2.12 2.09-3.567 2.025-1.868.026-3.591-1.472-3.883-3.305a4 4 0 0 1 .984-3.41c.118-.141.257-.258.396-.375.101-.085.203-.17.297-.265",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15.982,
  cy: 16,
  r: 11.478,
  stroke: "currentColor",
  strokeWidth: 1.565
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgObsLogo);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };